import { useQuery } from '@tanstack/react-query';

import { SidebarLayout } from '@/components/layouts/SidebarLayout';
import { AdminLevelNodeAccordion } from '@/components/tree-map/AdminLevelNodeAccordion';
import { LocationLeafs } from '@/components/tree-map/LocationLeafs';
import { QueryKeys } from '@/services/QueryKeys';
import { AdminLevelsService, AdminLevelType } from '@/services/api';

export function AdminLevelsTreePage() {
  const filter = { type: [AdminLevelType.GOVERNMENT_DISTRICT], depth: 2 };
  const { data = [] } = useQuery({
    queryKey: QueryKeys.adminLevels.allFilter(filter),
    queryFn: () => AdminLevelsService.findAll(filter),
  });

  return (
    <SidebarLayout type="tabs" navigationItems={data.map(({ name }) => name)}>
      {(tab: number) =>
        data[tab]?.children?.map((adminLevel) => (
          <AdminLevelNodeAccordion key={adminLevel.id} actions={[]} adminLevel={adminLevel} title={adminLevel.name}>
            {adminLevel.children?.map((municipality) => (
              <AdminLevelNodeAccordion
                key={municipality.id}
                actions={[]}
                adminLevel={municipality}
                title={municipality.name}
              >
                <LocationLeafs id={municipality.id} queryFn={AdminLevelsService.findOne} type="AdminLevel" />
              </AdminLevelNodeAccordion>
            ))}
          </AdminLevelNodeAccordion>
        ))
      }
    </SidebarLayout>
  );
}
